export default __webpack_public_path__ + "static/media/LeasePlan-Regular.91fcec02.woff";